/* eslint-disable react/jsx-key */
import React, { useMemo, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  modifierCol,
  modifiedDateCol,
  // utilityHeader,
} from 'core/HeaderColTypeProps'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  getWindUtilityOperatorInfo,
  postWindUtilityOperatorInfo,
  deleteWindUtilityOperatorInfo,
} from 'api/pgads.js'
import { getCompanyNameMap, getUtilityNameMap } from 'core/selectors'
import CommonScreen from 'admin/component/CommonScreen'
import { Select, Input, Button } from 'antd'
import R from 'ramda'
import styled from 'styled-components'
import { STORE_UTILITY } from 'core/action-names'

const TableTD = styled.td`
  text-align: end;
`

const headers = [
  strCol({
    ident: 'utility',
    display: 'Utility',
    width: 200,
    isKey: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'companyId',
    display: 'Company',
    width: 300,
  }),
  strCol({
    ident: 'utilityName',
    display: 'Utility Name',
    width: 350,
    isRequired: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getWindUtilityOperatorInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postWindUtilityOperatorInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteWindUtilityOperatorInfo(apiTargetInfo)(data)

const title = 'Wind Utility/Operator'

const mapVal = R.compose(
  R.map(([key, text]) => ({ key, text, value: key })),
  R.sortBy(([, text]) => text.toLowerCase()),
  R.toPairs
)

const WindUtilityOperator = props => {
  const [insertEvent, setInsertEvent] = useState(false)

  const reloadUtilityNameMap = _ => {
    // props.saveUtility(data)
  }

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <table
        style={{
          width: '100%',
          borderSpacing: '5px',
          borderCollapse: 'inherit',
        }}
      >
        <tbody>
          <tr>
            <TableTD>Utility Id:</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                key="utility"
                value={insertData.utility}
                placeholder="Utility"
                name="utility"
                onChange={e =>
                  setInsertData({ ...insertData, utility: e.target.value })
                }
                maxLength={10}
              />
            </td>
            <TableTD>Company :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Select
                style={{ minWidth: '100%' }}
                placeholder="Company"
                onChange={value => {
                  if (value === '[]')
                    setInsertData({ ...insertData, companyId: undefined })
                  else setInsertData({ ...insertData, companyId: value })
                }}
              >
                <Select.Option value="[]">[]</Select.Option>
                {mapVal(props.companyNameMap).map(m => (
                  <Select.Option value={m.value}>{m.text}</Select.Option>
                ))}
              </Select>
            </td>
            <TableTD>Utility Name :</TableTD>
            <td style={{ minWidth: '150px' }}>
              <Input
                key="utilityName"
                value={insertData.utilityName}
                placeholder="Utility Name"
                name="utilityName"
                onChange={e =>
                  setInsertData({ ...insertData, utilityName: e.target.value })
                }
              />
            </td>
            <td style={{ width: '50px' }}>
              <Button type="primary" onClick={() => onAdd(true)}>
                Add
              </Button>
            </td>
            <td style={{ width: '100px' }}>
              <Button type="primary" onClick={() => onAdd(false)}>
                Add & Hide
              </Button>
            </td>
            <td>
              <Button type="danger" onClick={onCancel}>
                Cancel
              </Button>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }
  const comToSelect = useMemo(
    _ => {
      const obj = toSelectionColProps({
        '[]': '',
        ...props.companyNameMap,
      })
      return obj
    },
    [props.companyNameMap]
  )

  const headerWithFormatter = useMemo(
    _ =>
      headers.map(header =>
        header.ident === 'companyId'
          ? {
              ...header,
              ...comToSelect,
              dataFormatter: ({ value }) =>
                props.companyNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                props.companyNameMap[rowData.companyId] || rowData.companyId,
            }
          : // : header.ident === 'utility'
            // ? {
            //     ...header,
            //     sortIndexGetter: ({ rowData }) => rowData.utilityName,
            //   }
            header
      ),
    [comToSelect, props.companyNameMap]
  )
  const modifySaveDataBeforeSave = saveData => {
    return saveData.map(s => ({
      ...s,
      companyId:
        s.companyId === 'NULL' || s.companyId === '[]'
          ? undefined
          : s.companyId,
    }))
  }

  return (
    <CommonScreen
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      title={title}
      header={headerWithFormatter}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.utility}
      autoRetrieve
      widthOffset={150}
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      onRetrieveData={reloadUtilityNameMap}
      sortEnabled
      // sortOnData={sortOnData}
      sortOptions={[
        {
          ident: 'utilityName',
          display: 'Utility Name',
          sortOrder: 'asc',
        },
        {
          ident: 'companyId',
          display: 'Company',
          sortOrder: 'asc',
        },
      ]}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
})
const mapDispatchToMap = dispatch => ({
  saveUtility: utilities =>
    dispatch({ type: STORE_UTILITY, payload: utilities }),
})

export default connect(mapStateToProps, mapDispatchToMap)(WindUtilityOperator)
